import { Column, Columns } from '@vtex/admin-ui'
import {
  Accumulate,
  AccumulateManualPrices,
  Accumulations,
  AdditionalInformation,
  Affiliates,
  BIN,
  Budget,
  Cluster,
  Conditions,
  FirstPurchase,
  HistoricalPurchaseValue,
  Installments,
  ItemPriceRange,
  ListPrice,
  MarketingTags,
  MaxItemsPerAttribute,
  MaxItemsPerCart,
  MaxUsage,
  MaxUsagePerClient,
  OrderValue,
  Origin,
  PaymentMethods,
  PromotionHighlight,
  Restrictions,
  SalesChannels,
  Sellers,
  ShippingLocation,
  ShippingMethods,
  Storefront,
  Subscription,
  UTM,
  UTMICampaign,
} from 'ui'
import { GeneralInformation } from '../../GeneralInformation'
import { StackedBoxes } from '../../StackedBoxes'
import { RegularEffect } from './RegularEffect'

export default function RegularForm() {
  return (
    <Columns space="$space-20">
      <Column units={7}>
        <GeneralInformation />
        <RegularEffect name="regular" />
        <Conditions>
          <OrderValue name="conditions.orderValue" />
          <HistoricalPurchaseValue name="conditions.historicalPurchaseValue" />
          <ItemPriceRange name="conditions.itemPriceRange" />
          <ListPrice name="conditions.listPrice" />
          <BIN name="conditions.bin" />
          <MarketingTags name="conditions.marketingTags" />
          <Affiliates name="conditions.affiliates" />
          <Cluster name="conditions.cluster" />
          <ShippingLocation name="conditions.shippingLocation" />
          <ShippingMethods name="conditions.shippingMethods" />
          <PaymentMethods name="conditions.paymentMethods" />
          <Installments name="conditions.installments" />
          <UTM name="conditions.utm" />
          <UTMICampaign name="conditions.utmiCampaign" />
          <FirstPurchase name="conditions.firstPurchase" />
          <Subscription name="conditions.subscription" />
        </Conditions>
        <Restrictions>
          <MaxUsage name="restrictions.maxUsage" />
          <MaxUsagePerClient name="restrictions.maxUsagePerClient" />
          <MaxItemsPerCart name="restrictions.maxItemsPerCart" />
          <MaxItemsPerAttribute name="restrictions.maxItemsPerAttribute" />
        </Restrictions>
        <Accumulations>
          <Accumulate name="restrictions.accumulate" />
          <AccumulateManualPrices name="restrictions.accumulateWithManualPrices" />
        </Accumulations>
        <Storefront>
          <PromotionHighlight name="storefront.highlight" />
          <AdditionalInformation name="storefront.additionalInformation" />
        </Storefront>
      </Column>
      <Column>
        <StackedBoxes>
          <Origin name="restrictions.origin" />
          <SalesChannels name="restrictions.salesChannels" />
          <Budget name="restrictions.budget" />
          <Sellers name="restrictions.sellers" />
        </StackedBoxes>
      </Column>
    </Columns>
  )
}
